import React from 'react';
import styles from './spacing.module.scss';

export class Spacing extends React.Component<{}> {
  render() {
    return <div className={styles.container} />;
  }
}
